import React from 'react';
import './Reviews.css';

const reviewsData = [
  {
    text: 'You are on my fan list. Saving Grace is a smooth read. Look forward to the sequel! The mystery is on point with great historical references on Washington, D.C.',
    author: 'Arnicia Downing',
    source: 'Reader Review',
  },
  {
    text: 'Saving Grace is a great read that takes us into a DC kitchen & delivers a tasty, meaty sausage sandwich exposing who is really in charge of the ingredients. A Great Read!',
    author: 'Donne Trotter',
    source: 'Reader Review',
  },
  {
    text: 'Excellent mix of history, politics and romance, Saving Grace will pull you in and hold you til the very last page!',
    author: 'Shonitra Slayton',
    source: 'Reader Review',
  },
];

function Reviews() {
  return (
    <section className="reviews-section" id="reviews">
      <div className="reviews-inner">
        <div className="reviews-header reveal">
          <h2>PRAISE FOR SAVING GRACE</h2>
          <div className="red-rule"></div>
        </div>
        <div className="reviews-grid">
          {reviewsData.map((review, i) => (
            <div className="review-card reveal" key={i}>
              <div className="review-stars">
                {[...Array(5)].map((_, j) => (
                  <span key={j}>★</span>
                ))}
              </div>
              <p className="review-text">{review.text}</p>
              <p className="review-author">{review.author}</p>
              <p className="review-source">{review.source}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Reviews;
